module.exports = __webpack_public_path__ + "static/pool1-650f401b0bd00b8954622886efd72b65.jpg";